export const classNames = (classes: string, somethingElse: string) => {
  const finalClasses = classes + ' ' + somethingElse;
  return finalClasses.split(' ').filter(Boolean).join(' ');
};
